import { render, staticRenderFns } from "./NuevoCat.vue?vue&type=template&id=ac8e89c2&scoped=true&"
import script from "./NuevoCat.vue?vue&type=script&lang=js&"
export * from "./NuevoCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8e89c2",
  null
  
)

export default component.exports